import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

// ******************************************
//     ReqSpec表示区分（チェックボックス）
// ******************************************
export class CustomCheckBoxReqSpec extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('customCheckboxReqSpec', () => {
      // The button will be an instance of ButtonView.
      const button = new ButtonView();
      const bind = button.bindTemplate;

      // チェックボックス　表示データ
      button.setTemplate({
        tag: 'div',
        children: [
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkReqSpec',
                  checked: 'true',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('ReqSpec表示') + ' ',
            ],
            // tag: "input",
            attributes: {
              for: 'chkReqSpec',
              type: 'checkbox',
            },
          },
        ],
      });

      // -----------------------------------------------------
      //   チェックボックス　クリックイベント
      //   CKEditor内のハイライトの表示/非表示
      //      styles.css に記載
      // -----------------------------------------------------
      button.on('clicked', (evt, data) => {
        let inputCheckBox = document.getElementById(data.target.id);

        if (inputCheckBox.checked == true) {
          const fsrIds = document.getElementById('fsrIds').value;
          if (!fsrIds) return;
          fsrIds.split(',').forEach(function (fsrId) {
            let elements = document.querySelectorAll('[fsr_id=' + fsrId + ']');
            for (let i = 0; i < elements.length; i++) {
              elements.item(i).setAttribute('reqspecdisp', 'on');
            }
          });
        } else {
          // ハイライトを消す
          document.querySelectorAll('[reqspecdisp]').forEach(function (element) {
            element.removeAttribute('reqspecdisp');
          });
        }
      });

      return button;
    });
  }
}
